import axiosInstance from "../../Utils/axiosInstance";

// export const getAccountManagementNotification = async () => {
//   try {
//     const response = await axiosInstance.get(
//       "api/key_account_management/getStakeHolderNotificationStatus"
//     );
//     return response?.data;
//   } catch (error) {
//     console.error("Error:", error?.response?.data);
//     return error?.response?.data;
//   }
// };
export const getNotification = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/general/getAllNotificationNew?stakeHolderEmail=" + payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface notificationPayload {
    notificationIDs: string[];
}
export const updateNotificationReadStatus = async (
    payload: notificationPayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/general/updateNotificationReadStatus",
            payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
